export default "__VITE_ASSET__Bjr3rk6q__"